import { OeKpis } from "aint-types";

import { OeKpisDataGridRow } from "./oe-kpis-data-grid";

export const OE_KPIS_DATA_GRID_ROWS: OeKpisDataGridRow[] = [
  {
    id: 1,
    kpi: "Policies",
    field: "policies",
  },
  {
    id: 2,
    kpi: "TBV",
    field: "tbv",
  },
  {
    id: 3,
    kpi: "TIE",
    field: "tie",
  },
  {
    id: 4,
    kpi: "t/o Total HR costs portion of TIE",
    field: "hrCostsOfTie",
  },
  {
    id: 5,
    kpi: "t/o Other costs portion of TIE",
    field: "otherCostsOfTie",
  },
  {
    id: 6,
    kpi: "Total OE FTEs",
    field: "totalOeFtes",
  },
  {
    id: 7,
    kpi: "t/o Total Internal FTEs",
    field: "internalOeFtes",
  },
  {
    id: 8,
    kpi: "t/o Total External FTEs",
    field: "externalOeFtes",
  },
  {
    id: 9,
    kpi: "Operating Profit",
    field: "operatingProfit",
  },
  {
    id: 10,
    kpi: "Factor Productivity (Policies)",
    field: "factorProductivityPolicies",
  },
  {
    id: 11,
    kpi: "Factor Productivity (TBV)",
    field: "factorProductivityTbv",
  },
  {
    id: 12,
    kpi: "TIEPo",
    field: "tiePo",
  },
  {
    id: 13,
    kpi: "TIE over TBV",
    field: "tieOverTbv",
  },
  {
    id: 14,
    kpi: "Total Internal FTEs in scope for Rapid Productivity",
    field: "internalFteRapidProductivity",
  },
  {
    id: 15,
    kpi: "Total External FTEs in scope for Rapid Productivity",
    field: "externalFteRapidProductivity",
  },
  {
    id: 16,
    kpi: "FTE reduction from Rapid Productivity",
    field: "fteReductionRapidProductivity",
  },
  {
    id: 17,
    kpi: "Total Internal FTEs reduction",
    field: "internalFteReduction",
  },
  {
    id: 18,
    kpi: "Total External FTEs reduction",
    field: "externalFteReduction",
  },
  {
    id: 19,
    kpi: "Total External FTEs",
    field: "externalFtes",
  },
];

export const INDEPENDENT_OE_KPI_FIELDS: (keyof OeKpis)[] = [
  "policies",
  "tbv",
  "tie",
  "hrCostsOfTie",
  "internalOeFtes",
  "externalOeFtes",
  "operatingProfit",
  "internalFteRapidProductivity",
  "externalFteRapidProductivity",
  "fteReductionRapidProductivity",
  "internalFteReduction",
  "externalFteReduction",
  "externalFtes",
];

export const OE_KPI_FIELDS_WITH_DEPENDNCIES: (keyof OeKpis)[] = [
  "otherCostsOfTie",
  "totalOeFtes",
  "factorProductivityPolicies",
  "factorProductivityTbv",
  "tiePo",
  "tieOverTbv",
];
